// YouTube Studio visibility (mirror of functions/marketing/youtubeStudio.accessFor; the server enforces it too).
// 'hidden' (Amanda, hard block: no menu item, no page) | 'comingSoon' (everyone else) | 'full' (Kelly, or users/<uid>/youtubeStudioEnabled === true).
import { useEffect, useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebaseConfig';
import { useAuth } from '../context/AuthContext';

export const KELLY_UID = 'izVJWBDFcgZRFM1lzFDd8K5P6bU2';
export const HIDDEN_EMAILS = ['amanda.bolduc@exprealty.com'];
const low = (s) => String(s || '').trim().toLowerCase();

export function youtubeStudioAccess(uid, user = {}, authEmail = '') {
  if (!uid) return 'hidden';
  const u = user || {}; const p = u.profile || {};
  if ([authEmail, u.email, u.contactEmail, p.email, p.contactEmail].some((e) => HIDDEN_EMAILS.includes(low(e))) || u.youtubeStudioHidden === true) return 'hidden';
  const flag = u.youtubeStudioEnabled;
  return (typeof flag === 'boolean' ? flag : uid === KELLY_UID) ? 'full' : 'comingSoon';
}

// null while loading (treated as hidden so the item never flashes for Amanda).
export function useYoutubeStudioAccess() {
  const { user, viewAsUser } = useAuth();
  const uid = user?.uid;
  const email = viewAsUser ? viewAsUser.email : user?.email;
  const [access, setAccess] = useState(null);
  useEffect(() => {
    let live = true;
    if (!uid) { setAccess('hidden'); return undefined; }
    get(ref(database, `users/${uid}`)).then((s) => { if (live) setAccess(youtubeStudioAccess(uid, s.val() || {}, email)); }).catch(() => { if (live) setAccess('hidden'); });
    return () => { live = false; };
  }, [uid, email]);
  return access;
}
